import { render, staticRenderFns } from "./ImageIcon.vue?vue&type=template&id=1def1458"
import script from "./ImageIcon.vue?vue&type=script&lang=js"
export * from "./ImageIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports